const colorThemeTypes = {
    SET_COLOR_THEME: "colorTheme/set", 
}

export default colorThemeTypes;